(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vinbiru-premium-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vinbiru-slideshow')) {
    class VinbiruSlideshow extends HTMLElement {
      connectedCallback() {
        if (this._connected) return;
        this._connected = true;
        this.viewport = this.querySelector('.vb-slideshow__viewport');
        this.slides = Array.from(this.querySelectorAll('.vb-slide'));
        this.dots = Array.from(this.querySelectorAll('[data-go-to]'));
        this.index = Math.max(0, this.slides.findIndex(slide => slide.classList.contains('is-active')));
        this._swipe = null;
        this._hoverPaused = false;
        this._focusPaused = false;
        this._editorPaused = false;
        this._holdAutoplayUntil = 0;
        this._mobileMedia = window.matchMedia('(max-width: 749px)');

        this._postponeAutoplay = () => {
          this._holdAutoplayUntil = Date.now() + 4500;
        };

        this._handleClick = event => {
          const nav = event.target.closest('[data-direction]');
          const dot = event.target.closest('[data-go-to]');
          if (nav) {
            this.go(this.index + (nav.dataset.direction === 'next' ? 1 : -1));
            this._postponeAutoplay();
          } else if (dot) {
            this.go(Number(dot.dataset.goTo));
            this._postponeAutoplay();
          }
        };
        this._handleEnter = () => {
          if (window.matchMedia('(hover: hover)').matches) this._hoverPaused = true;
        };
        this._handleLeave = () => { this._hoverPaused = false; };
        this._handleFocusIn = () => { this._focusPaused = true; };
        this._handleFocusOut = event => {
          if (!this.contains(event.relatedTarget)) this._focusPaused = false;
        };

        /* One-finger mobile swipe: avoid triggering on CTA links / controls. */
        this._handleTouchStart = event => {
          if (this.dataset.mobileSwipe === 'false' || !this._mobileMedia.matches || this.slides.length < 2) return;
          if (event.touches.length !== 1) return;
          if (event.target.closest('a, button, input, select, textarea, [contenteditable="true"]')) return;
          const touch = event.touches[0];
          this._swipe = {
            id: touch.identifier,
            x: touch.clientX,
            y: touch.clientY,
            lastX: touch.clientX,
            lastY: touch.clientY,
            direction: null
          };
        };
        this._handleTouchMove = event => {
          if (!this._swipe) return;
          if (event.touches.length !== 1) {
            this._swipe = null;
            return;
          }
          const touch = event.touches[0];
          if (touch.identifier !== this._swipe.id) return;
          this._swipe.lastX = touch.clientX;
          this._swipe.lastY = touch.clientY;
          const dx = touch.clientX - this._swipe.x;
          const dy = touch.clientY - this._swipe.y;
          if (!this._swipe.direction && (Math.abs(dx) > 10 || Math.abs(dy) > 10)) {
            this._swipe.direction = Math.abs(dx) > Math.abs(dy) * 1.2 ? 'horizontal' : 'vertical';
          }
          if (this._swipe.direction === 'horizontal' && event.cancelable) event.preventDefault();
        };
        this._handleTouchEnd = event => {
          if (!this._swipe) return;
          const swipe = this._swipe;
          this._swipe = null;
          const touch = Array.from(event.changedTouches).find(item => item.identifier === swipe.id);
          if (!touch) return;
          const dx = touch.clientX - swipe.x;
          const dy = touch.clientY - swipe.y;
          const minDistance = Math.max(45, Math.min(85, (this.viewport?.clientWidth || 375) * 0.12));
          if (swipe.direction !== 'vertical' && Math.abs(dx) >= minDistance && Math.abs(dx) > Math.abs(dy) * 1.2) {
            this.go(this.index + (dx < 0 ? 1 : -1));
            this._postponeAutoplay();
          }
        };
        this._handleTouchCancel = () => { this._swipe = null; };

        this._handleBlockSelect = event => {
          if (event.detail.sectionId !== this.dataset.sectionId) return;
          const i = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (i >= 0) { this._editorPaused = true; this.go(i); }
        };
        this._handleBlockDeselect = event => {
          if (event.detail.sectionId === this.dataset.sectionId) this._editorPaused = false;
        };
        this._handleSectionSelect = event => {
          if (event.detail.sectionId === this.dataset.sectionId) this._editorPaused = true;
        };
        this._handleSectionDeselect = event => {
          if (event.detail.sectionId === this.dataset.sectionId) this._editorPaused = false;
        };

        this.addEventListener('click', this._handleClick);
        this.addEventListener('mouseenter', this._handleEnter);
        this.addEventListener('mouseleave', this._handleLeave);
        this.addEventListener('focusin', this._handleFocusIn);
        this.addEventListener('focusout', this._handleFocusOut);
        if (this.viewport) {
          this.viewport.addEventListener('touchstart', this._handleTouchStart, { passive: true });
          this.viewport.addEventListener('touchmove', this._handleTouchMove, { passive: false });
          this.viewport.addEventListener('touchend', this._handleTouchEnd, { passive: true });
          this.viewport.addEventListener('touchcancel', this._handleTouchCancel, { passive: true });
        }
        document.addEventListener('shopify:block:select', this._handleBlockSelect);
        document.addEventListener('shopify:block:deselect', this._handleBlockDeselect);
        document.addEventListener('shopify:section:select', this._handleSectionSelect);
        document.addEventListener('shopify:section:deselect', this._handleSectionDeselect);
        this.go(this.index);

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.dataset.autoplay === 'true' && this.dataset.editor !== 'true' && this.slides.length > 1 && !reducedMotion) {
          const ms = Math.max(3000, Number(this.dataset.interval) || 5000);
          this._timer = window.setInterval(() => {
            if (!this._hoverPaused && !this._focusPaused && !this._editorPaused &&
                !this._swipe && !document.hidden && Date.now() >= this._holdAutoplayUntil) {
              this.go(this.index + 1);
            }
          }, ms);
        }
      }
      go(next) {
        if (this.slides.length === 0) return;
        this.index = (next + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
        });
        this.dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === this.index);
          dot.setAttribute('aria-current', String(i === this.index));
        });
      }
      disconnectedCallback() {
        window.clearInterval(this._timer);
        this.removeEventListener('click', this._handleClick);
        this.removeEventListener('mouseenter', this._handleEnter);
        this.removeEventListener('mouseleave', this._handleLeave);
        this.removeEventListener('focusin', this._handleFocusIn);
        this.removeEventListener('focusout', this._handleFocusOut);
        if (this.viewport) {
          this.viewport.removeEventListener('touchstart', this._handleTouchStart);
          this.viewport.removeEventListener('touchmove', this._handleTouchMove);
          this.viewport.removeEventListener('touchend', this._handleTouchEnd);
          this.viewport.removeEventListener('touchcancel', this._handleTouchCancel);
        }
        document.removeEventListener('shopify:block:select', this._handleBlockSelect);
        document.removeEventListener('shopify:block:deselect', this._handleBlockDeselect);
        document.removeEventListener('shopify:section:select', this._handleSectionSelect);
        document.removeEventListener('shopify:section:deselect', this._handleSectionDeselect);
        this._swipe = null;
        this._connected = false;
      }
    }
    customElements.define('vinbiru-slideshow', VinbiruSlideshow);
  }

  } catch(e) { console.error(e); }
})();
})();
